export default {"src":"/evde-internet/_next/static/media/replay.eed1e6bb.svg","height":24,"width":24};